import { IconPropsType } from '..';

export const ReportIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path d="M-6.10352e-05 -1.52588e-05V16H8.76994L12.2399 12.53V-1.52588e-05H-6.10352e-05ZM10.6399 11.872H8.11994V14.4H1.59994V1.59998H10.6399V11.872ZM2.95394 11.072V9.47198H6.15394V11.072H2.95394ZM2.95394 7.87198V6.27199H7.75394V7.87198H2.95394ZM2.95394 4.67199V3.07199H9.35394V4.67199H2.95394Z" />
  </svg>
);
